import { Node } from "@tiptap/core";

const AnswerAddedNode = Node.create({
  name: "answer-added",
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      qid: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "answer-added",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["answer-added", HTMLAttributes];
  },

  addNodeView() {
    return ({ node }) => {
      const { qid } = node.attrs;
      const dom = document.createElement("div");

      dom.style.width = "100%";
      dom.style.height = "1px";
      dom.style.backgroundColor = "#ccc";

      dom.dataset.qid = qid;

      return {
        dom,
      };
    };
  },
});

export default AnswerAddedNode;
